export { default } from "./setting.api"
